import _extends from "@swc/helpers/src/_extends.mjs";
import _object_destructuring_empty from "@swc/helpers/src/_object_destructuring_empty.mjs";
import React from 'react';
import CommentBoxAvatar from '../../../../lego/CommentBoxAvatar';
import CommentBoxEditor from '../../../../lego/CommentBoxEditor';
import CommentBoxLayout from '../../../../layouts/CommentBoxLayout';
const EditorView = (_param)=>/*#__PURE__*/ {
    var rest = _extends({}, _object_destructuring_empty(_param));
    return React.createElement(CommentBoxLayout, {
        avatar: /*#__PURE__*/ React.createElement(CommentBoxAvatar, null),
        content: /*#__PURE__*/ React.createElement(CommentBoxEditor, _extends({}, rest))
    });
};
EditorView.displayName = 'EditorView';
export default EditorView;
